import React from "react";
import { Link, useLocation } from "react-router-dom";
import Image from "../../../assets/Discount_App_logo.png";

export default function Sidebar() {
  const location = useLocation();

  const isActive = (path) => {
    const currentPath = location.pathname;
    return currentPath.startsWith(path);
  };

  const { pathname } = useLocation();

  const isReportsActive = 
    pathname.startsWith("/business/reports") ||
    pathname.startsWith("/business/user-reports") ||
    pathname.startsWith("/business/offline-transaction-reports");

  const closeSidebar = () => {
    document.querySelector(".sidebar")?.classList.remove("show");
    document.querySelector(".sidebar-backdrop")?.classList.remove("show");
  };

  return (
    <div className="sidebar">
      <div className="text-center mb-3 d-flex align-items-center justify-content-between position-relative" style={{ minHeight: "80px", borderBottom: "1px solid #EEEEEE", padding: "12px 16px" }}>
        <div className="w-100 d-flex justify-content-center">
          <img src={Image} style={{ objectFit: "contain", maxHeight: "60px", maxWidth: "150px", width: "auto" }} className="img-fluid" alt="Logo" />
        </div>
        <button
          type="button"
          className="btn-close d-lg-none position-absolute"
          style={{ right: "12px", top: "16px" }}
          onClick={closeSidebar}
          aria-label="Close sidebar"
        />
      </div>
      <nav className="nav flex-column px-3 subtitle-3">
        <Link className={`nav-link ${isActive("/business/dashboard") ? "active" : ""}`} to={"/business/dashboard"} onClick={closeSidebar}>
          <i className="fi fi-rr-world" />
          Dashboard
        </Link>
        <Link className={`nav-link ${isActive("/business/coupons") ? "active" : ""}`} to={"/business/coupons/1"} onClick={closeSidebar}>
          <i className="ri-discount-percent-line"></i>
          Buy 1 Get 2
        </Link>
        <Link className={`nav-link ${isActive("/business/users") ? "active" : ""}`} to={"/business/users/1"} onClick={closeSidebar}>
          <i class="fi fi-rr-user"></i>
          Customers
        </Link>
        <Link className={`nav-link ${isActive("/business/transactions") ? "active" : ""}`} to={"/business/transactions"} onClick={closeSidebar}>
          <i class="fi fi-rr-credit-card"></i>
          Transactions
        </Link>
        <Link className={`nav-link ${isReportsActive ? "active" : ""}`} to="/business/reports" onClick={closeSidebar}>
          <i className="fi fi-rr-chart-line-up"></i>
          Reports
        </Link>
        <Link className={`nav-link ${isActive("/business/support") ? "active" : ""}`} to="/business/support" onClick={closeSidebar}>
          <i className="fi fi-bs-user-headset" />
          Support
        </Link>
      </nav>
    </div>
  );
}
